export const FORM_IDS = {
  CREATE: "create-user-form",
  EDIT: "edit-user-form",
  DELETE: "delete-user-form",
  RESET_PASSWORD: "reset-password-form",
};
